import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import Carrusel from '../_app/cuchillo/components/Carrusel';
import { GetBy } from '../_app/cuchillo/core/Element';
import gsap from 'gsap';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import VisorVideos from '../layout/VisorVideos';

class ScrollItem__BlockStories extends Scroll_Item {
  _carrusel;
  _call;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.isFirstPlay = true;
    const visorSecuencial = new VisorVideos(GetBy.class("module-stories", this.item)[0], { loop: false });
    this._carrusel = new Carrusel(Metrics.WIDTH, GetBy.class("__carrusel", this.item)[0], GetBy.class("__carrusel", this.item)[1]);

    this._carrusel.multiplicator = .5;
            
    this._call = () => this.loop();
    this.onShow = () => {
      if(this.isFirstPlay) {
        this.isFirstPlay = false;
        visorSecuencial.change(0);
      } else {
        visorSecuencial.play();
      }
      gsap.ticker.add(this._call);
    };

    this.onHide = () => {
      visorSecuencial.pause();
      gsap.ticker.remove(this._call);
    };
  }

  resize(__w, __h) {
    super.resize(__w, __h)
    if(this._carrusel) {
      this._carrusel.resize(Metrics.WIDTH);
    }
  }

  loop() {
    this._carrusel.loop();
  }

  dispose() {
    super.dispose();
   
  }
}

Scroll._registerClass('BlockStories', ScrollItem__BlockStories);

export default ScrollItem__BlockStories;
